import React, { useState, useEffect, useRef } from "react";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import Messages from "../../../constants/Messages";
import { useShowAlert } from "../../../context/AlertContext";
import { usePermission } from "../../../context/PermissionContext";
import { CheckIcon, ChevronRightIcon, CloseIcon } from "../../../constants/Icons";

const PreSaleModeModal = ({ selectedMode, onClose, onConfirm }) => {
  const showAlert = useShowAlert();
  const { viewOptionSecondLevel } = usePermission();
  const modeMap = {
    proforma: "PROFORMA_INVOICE",
    estimation: "ESTIMATION",
    quotation: "QUOTATION",
  };

  const [selectedOption, setSelectedOption] = useState(
    modeMap[selectedMode] || "PROFORMA_INVOICE",
  );
  const options = ["PROFORMA_INVOICE", "ESTIMATION", "QUOTATION"];
  //   const options =[
  //     "BILL",
  //     "INVOICE"
  //   ]
  const containerRef = useRef(null);

  const handleRadioChange = (option) => {
    setSelectedOption(option);
  };

  const handleConfirm = () => {
    if (!selectedOption) {
      showAlert("warning", Messages.ERROR.MODE_EMPTY);
      return;
    }

    onConfirm(selectedOption);
    onClose();
  };

  const handleKeyDown = (e) => {
    switch (e.key) {
      case "ArrowDown": {
        e.preventDefault();
        const currentIndex = options.indexOf(selectedOption);
        const nextIndex =
          currentIndex === -1 ? 0 : (currentIndex + 1) % options.length;
        setSelectedOption(options[nextIndex]);
        break;
      }

      case "ArrowUp": {
        e.preventDefault();
        const currentIndex = options.indexOf(selectedOption);
        const prevIndex =
          currentIndex === -1
            ? options.length - 1
            : (currentIndex - 1 + options.length) % options.length;
        setSelectedOption(options[prevIndex]);
        break;
      }

      case "Enter":
        e.preventDefault();
        handleConfirm();
        break;

      default:
        break;
    }
  };
  
  useEffect(() => {
    containerRef.current?.focus(); // focus to listen to keyboard
  }, []);

  useEffect(() => {
    setSelectedOption(modeMap[selectedMode] || "PROFORMA_INVOICE");
  }, [selectedMode]);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleEsc);

    // Cleanup on unmount
    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, [onClose]);

  return (
    <div>
      <div className="modal-backdrop show"></div>
      <div
        className="modal show"
        id="ModeModal"
        tabIndex="0"
        aria-modal="true"
        role="dialog"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-sm">
          <div
            className="modal-content"
            ref={containerRef}
            tabIndex={-1}
            onKeyDown={handleKeyDown}
          >
            <div className="modal-header">
              <h6 className="modal-title"> Are you want to generate? </h6>
              <button
                type="button"
                onClick={onClose}
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div className="model-body">
              <div className="row mx-2">
                <div className="col-12 mb-2">
                  <div
                    className={`form-check form-chexk-input-tax-model custom-option custom-option-basic ${
                      selectedOption === "PROFORMA_INVOICE" ? "checked" : ""
                    }`}
                  >
                    <label
                      className="form-check-label custom-option-content"
                      htmlFor="preSaleMode1"
                    >
                      <input
                        className="form-check-input fs-6"
                        type="radio"
                        id="preSaleMode1"
                        checked={selectedOption === "PROFORMA_INVOICE"}
                        onChange={() => handleRadioChange("PROFORMA_INVOICE")}
                      />

                      <span className="custom-option-header">
                        <span className="h6 mb-0 radioText">
                          Proforma Invoice
                        </span>

                        <span className="radioText">
                          <ChevronRightIcon iClass={"fs-6"}/>
                        </span>
                      </span>
                    </label>
                  </div>
                </div>

                <div className="col-12 mb-2">
                  <div
                    className={`form-check form-chexk-input-tax-model custom-option custom-option-basic ${
                      selectedOption === "ESTIMATION" ? "checked" : ""
                    }`}
                  >
                    <label
                      className="form-check-label custom-option-content"
                      htmlFor="preSaleMode2"
                    >
                      <input
                        className="form-check-input fs-6"
                        type="radio"
                        id="preSaleMode2"
                        checked={selectedOption === "ESTIMATION"}
                        onChange={() => handleRadioChange("ESTIMATION")}
                      />

                      <span className="custom-option-header">
                        <span className="h6 mb-0 radioText">Estimation</span>

                        <span className="radioText">
                        <ChevronRightIcon iClass={"fs-6"}/>
                        </span>
                      </span>
                    </label>
                  </div>
                </div>

                <div className="col-12">
                  <div
                    className={`form-check form-chexk-input-tax-model custom-option custom-option-basic ${
                      selectedOption === "QUOTATION" ? "checked" : ""
                    }`}
                  >
                    <label
                      className="form-check-label custom-option-content"
                      htmlFor="preSaleMode3"
                    >
                      <input
                        className="form-check-input fs-6"
                        type="radio"
                        id="preSaleMode3"
                        checked={selectedOption === "QUOTATION"}
                        onChange={() => handleRadioChange("QUOTATION")}
                      />

                      <span className="custom-option-header">
                        <span className="h6 mb-0 radioText">Quotation</span>

                        <span className="radioText">
                        <ChevronRightIcon iClass={"fs-6"}/>
                        </span>
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer d-block">
              <button
                onClick={onClose}
                type="button"
                data-bs-dismiss="modal"
                className="btn btn-outline-secondary text-left"
              >
                <CloseIcon iClass={"fs-15"}/> Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary text-right"
                onClick={handleConfirm}
              >
                <CheckIcon/> Continue
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreSaleModeModal;
